// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AccordionPlus: React.FC<{ size?: number; color1?: string; className?: string }> = ({ size = 21, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 21 21" width={size} height={size}>
        <path
            fill="currentColor"
            d="M11.02 1.02a.77.77 0 0 0-.77-.77.77.77 0 0 0-.77.77v8.46H1.02a.77.77 0 0 0-.77.77c0 .423.346.77.77.77h8.46v8.46c0 .424.347.77.77.77s.77-.346.77-.77v-8.46h8.46c.424 0 .77-.347.77-.77a.77.77 0 0 0-.77-.77h-8.46z"
        />
    </svg>
);

export default React.memo(AccordionPlus);
